import MockAdapter from "axios-mock-adapter"
import {
  Candidate,
  CandidateTimeline,
} from "@/modules/recruitment/candidates/dtos/Candidate"
import { ApplicationListItem } from "@/modules/recruitment/applications/dtos/ApplicantListItem"

export const mockCandidates: Candidate[] = [
  {
    id: "cand-1",
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@example.com",
    phone: "+27 82 123 4567",
    location: "Cape Town, South Africa",
    cvUrl: "/documents/cv-sarah-johnson.pdf",
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["React", "TypeScript", "Node.js", "Python", "AWS"],
  },
  {
    id: "cand-2",
    firstName: "Michael",
    lastName: "Chen",
    email: "michael.chen@example.com",
    phone: "+27 83 234 5678",
    location: "Johannesburg, South Africa",
    cvUrl: "/documents/cv-michael-chen.pdf",
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["Java", "Spring Boot", "Microservices", "Docker", "Kubernetes"],
  },
  {
    id: "cand-3",
    firstName: "Emily",
    lastName: "Williams",
    email: "emily.williams@example.com",
    phone: "+27 84 345 6789",
    location: "Durban, South Africa",
    cvUrl: "/documents/cv-emily-williams.pdf",
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["UI/UX Design", "Figma", "Adobe XD", "Prototyping"],
  },
  {
    id: "cand-4",
    firstName: "David",
    lastName: "Brown",
    email: "david.brown@example.com",
    phone: "+27 85 456 7890",
    location: "Pretoria, South Africa",
    cvUrl: "/documents/cv-david-brown.pdf",
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["C#", ".NET Core", "SQL Server", "Azure", "DevOps"],
  },
  {
    id: "cand-5",
    firstName: "Jessica",
    lastName: "Martinez",
    email: "jessica.martinez@example.com",
    phone: "+27 86 567 8901",
    location: "Port Elizabeth, South Africa",
    cvUrl: "/documents/cv-jessica-martinez.pdf",
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["Project Management", "Agile", "Scrum", "JIRA", "Confluence"],
  },
  {
    id: "cand-6",
    firstName: "James",
    lastName: "Anderson",
    email: "james.anderson@example.com",
    phone: "+27 87 678 9012",
    location: "Bloemfontein, South Africa",
    cvUrl: "/documents/cv-james-anderson.pdf",
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["PHP", "Laravel", "MySQL", "Redis"],
  },
  {
    id: "cand-7",
    firstName: "Sophia",
    lastName: "Taylor",
    email: "sophia.taylor@example.com",
    phone: "+27 88 789 0123",
    location: "Cape Town, South Africa",
    cvUrl: "/documents/cv-sophia-taylor.pdf",
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    skills: [
      "Data Science",
      "Python",
      "Machine Learning",
      "TensorFlow",
      "Pandas",
    ],
  },
  {
    id: "cand-8",
    firstName: "Daniel",
    lastName: "Wilson",
    email: "daniel.wilson@example.com",
    phone: "+27 89 890 1234",
    location: "Johannesburg, South Africa",
    cvUrl: "/documents/cv-daniel-wilson.pdf",
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["DevOps", "Jenkins", "Terraform", "Ansible", "Linux"],
  },
  {
    id: "cand-9",
    firstName: "Olivia",
    lastName: "Moore",
    email: "olivia.moore@example.com",
    phone: "+27 82 901 2345",
    location: "Durban, South Africa",
    cvUrl: "/documents/cv-olivia-moore.pdf",
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    skills: ["Mobile Development", "React Native", "iOS", "Android", "Flutter"],
  },
  {
    id: "cand-10",
    firstName: "Ryan",
    lastName: "Garcia",
    email: "ryan.garcia@example.com",
    phone: "+27 83 012 3456",
    location: "Pretoria, South Africa",
    cvUrl: "/documents/cv-ryan-garcia.pdf",
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    skills: [
      "Cybersecurity",
      "Penetration Testing",
      "Network Security",
      "CISSP",
    ],
  },
]

// Mock timeline data
const mockTimelines: Record<string, CandidateTimeline[]> = {
  "cand-1": [
    {
      id: "timeline-1",
      eventType: "Application Submitted",
      description:
        "Candidate submitted application for Senior Frontend Developer position",
      createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: "timeline-2",
      eventType: "Application Reviewed",
      description: "Application reviewed by hiring manager",
      createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: "timeline-3",
      eventType: "Phone Screen Scheduled",
      description: "Initial phone screening scheduled for next week",
      createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: "timeline-4",
      eventType: "Status Updated",
      description: "Moved to Candidate stage",
      createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    },
  ],
  "cand-2": [
    {
      id: "timeline-5",
      eventType: "Application Submitted",
      description: "Applied for Backend Developer role",
      createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: "timeline-6",
      eventType: "Screened",
      description: "Passed initial screening",
      createdAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: "timeline-7",
      eventType: "Technical Interview",
      description: "Completed technical assessment with high scores",
      createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    },
  ],
}

export const mockApplicants: ApplicationListItem[] = []

const mockPagedCandidates = mockCandidates.map((c, i) => ({
  id: c.id,
  firstName: c.firstName,
  lastName: c.lastName,
  email: c.email,
  phone: c.phone ?? null,
  location: c.location ?? null,
  skills: c.skills ?? [],
  certifications: [],
  experienceYears: i * 2,
  education: null,
  cvUrl: c.cvUrl ?? null,
  applications: [
    {
      applicationId: `app-${c.id}`,
      vacancyId: `vac-${i + 1}`,
      vacancyTitle: `Vacancy ${i + 1}`,
      stage: ["Applied", "Screened", "Candidate", "Hired", "Rejected"][i % 5],
      matchScore: i % 3 === 0 ? null : (i + 1) * 10,
    },
  ],
}))

export function registerMockCandidateService(mock: MockAdapter) {
  mock.onGet(/\/api\/organizations\/[^/]+\/candidates\/distinct-skills/).reply(() => {
    const allSkills = mockCandidates.flatMap((c) => c.skills ?? [])
    const unique = [...new Set(allSkills.map((s) => s.toLowerCase()))].sort()
    const skills = unique.map(
      (s) => allSkills.find((sk) => sk.toLowerCase() === s) ?? s,
    )
    return [200, { skills }]
  })

  mock.onGet(/\/api\/organizations\/[^/]+\/candidates$/).reply((config) => {
    const params = config.params as Record<string, string | undefined> | undefined
    const page = Number(params?.page ?? 1)
    const pageSize = Number(params?.pageSize ?? 20)
    const search = params?.search?.toLowerCase()

    let filtered = mockPagedCandidates
    if (search) {
      filtered = filtered.filter(
        (c) =>
          c.firstName.toLowerCase().includes(search) ||
          c.lastName.toLowerCase().includes(search) ||
          c.email.toLowerCase().includes(search) ||
          (c.location?.toLowerCase().includes(search) ?? false) ||
          c.skills.some((s) => s.toLowerCase().includes(search)),
      )
    }

    const start = (page - 1) * pageSize
    return [
      200,
      {
        items: filtered.slice(start, start + pageSize),
        totalCount: filtered.length,
        page,
        pageSize,
      },
    ]
  })

  mock.onGet("/api/candidates").reply((_config) => {
    return [200, mockCandidates]
  })

  // Scoped catch-all: only intercept the legacy /api/candidates/* routes so
  // this handler cannot swallow unrelated requests (which broke every mock
  // registered after it). All other traffic falls through to the global
  // fallback registered last in setupMocks().
  mock.onAny(/\/api\/candidates\//).reply((config) => {
    if (
      config.method === "get" &&
      config.url?.startsWith("/api/candidates/") &&
      !config.url.includes("/stage") &&
      !config.url.includes("/timeline")
    ) {
      const id = config.url.split("/").pop()
      const candidate = mockCandidates.find((c) => c.id === id)

      if (candidate) {
        return [200, candidate]
      }
      return [404, { message: "Candidate not found" }]
    }

    // GET /api/candidates/:id/timeline - Get candidate timeline
    if (config.method === "get" && config.url?.includes("/timeline")) {
      const parts = config.url.split("/")
      const id = parts[parts.length - 2]
      const timeline = mockTimelines[id] || []

      return [200, timeline]
    }

    // PUT /api/candidates/:id - Update candidate
    if (config.method === "put" && config.url?.startsWith("/api/candidates/")) {
      const id = config.url.split("/").pop()
      const updates = JSON.parse(config.data) as Partial<Candidate>

      const candidateIndex = mockCandidates.findIndex((c) => c.id === id)

      if (candidateIndex !== -1) {
        mockCandidates[candidateIndex] = {
          ...mockCandidates[candidateIndex],
          ...updates,
          updatedAt: new Date().toISOString(),
        }

        return [200, mockCandidates[candidateIndex]]
      }

      return [404, { message: "Candidate not found" }]
    }

    // DELETE /api/candidates/:id - Delete candidate
    if (
      config.method === "delete" &&
      config.url?.startsWith("/api/candidates/")
    ) {
      const id = config.url.split("/").pop()
      const candidateIndex = mockCandidates.findIndex((c) => c.id === id)

      if (candidateIndex !== -1) {
        mockCandidates.splice(candidateIndex, 1)

        return [204]
      }

      return [404, { message: "Candidate not found" }]
    }

    // PATCH /api/candidates/:id/stage - Update candidate stage
    if (config.method === "patch" && config.url?.includes("/stage")) {
      const parts = config.url.split("/")
      const id = parts[parts.length - 2]

      const candidateIndex = mockCandidates.findIndex((c) => c.id === id)

      if (candidateIndex !== -1) {
        mockCandidates[candidateIndex].updatedAt = new Date().toISOString()

        return [200, mockCandidates[candidateIndex]]
      }

      return [404, { message: "Candidate not found" }]
    }

    return [404, { message: "Endpoint not found" }]
  })

  // POST /api/candidates - Create new candidate
  mock.onPost("/api/candidates").reply((config) => {
    const newCandidate = JSON.parse(config.data) as Partial<Candidate>
    const now = new Date().toISOString()

    const candidate: Candidate = {
      id: `cand-${Date.now()}`,
      firstName: newCandidate.firstName || "",
      lastName: newCandidate.lastName || "",
      email: newCandidate.email || "",
      phone: newCandidate.phone,
      location: newCandidate.location,
      cvUrl: newCandidate.cvUrl,
      createdAt: now,
      updatedAt: now,
      skills: newCandidate.skills || [],
    }

    mockCandidates.push(candidate)

    return [201, candidate]
  })

  // GET /api/applicants - Get applicants for organization
  mock.onGet("/api/applicants").reply((_config) => {
    return [200, mockCandidates]
  })
}
